import React from 'react';
import {
  TableCell,
  colors,
  TextField,
  InputAdornment
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {}
}));


export const CustomTableCell = ({ row, name, onChange, Adet, onayDurumu }) => {
  const classes = useStyles();
  return (
    <TableCell align="left" padding='none' className={classes.tableCell}>
      <TextField
        value={row[name]}
        name={name}
        type="number"
        onChange={e => onChange(e, row)}
        style={{ width: 80 }}
        inputProps={{ min: 0, style: { textAlign: 'center' } }}
        disabled={onayDurumu}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {row[name] === 0 || row.Count === undefined ? (
                ''
              ) : parseInt(Adet, 10) !== parseInt(row.Count, 10) ? (
                <WarningIcon style={{ color: colors.yellow[900] }} />
              ) : (
                <CheckIcon style={{ color: colors.green[900] }} />
              )}
            </InputAdornment>
          )
        }}
      />
    </TableCell>
  );
};
